<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.displayName"
              label="业务类型"
              removable
              :messages="message"
              :error="!!error.displayNameErrors.length"
              :error-messages="error.displayNameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="业务代码"
              removable
              :disabled="this.insertData.id!==null"
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="描述"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '../../utils/common'
import businessApi from '../../api/business'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        displayName: '',
        description: '',
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        displayNameErrors: [],
        descriptionErrors: [],
      },
      showId: false,
      title: '新增业务',
      submitButtonStatus: true,
    }
  },
  created () {
    this.getBusiness()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.displayNameErrors.length
    },
  },
  methods: {
    getBusiness () {
      const params = this.$route.params
      const query = this.$route.query
      if (params.id != null) {
        this.showId = true
        this.title = '编辑业务'
        // 通过id获取详情
        businessApi.getBusiness(query.name).then(response => {
          copyObject(response.business, this.insertData)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        displayName: this.insertData.displayName,
        description: this.insertData.description,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        businessApi.updateBusiness(data).then(response => {
          if (response.success === true) {
            this.showToast('更新业务成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listBusiness' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        businessApi.createBusiness(data).then(response => {
          if (response.success === true) {
            this.showToast('添加业务成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listBusiness' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.displayNameErrors = this.insertData.displayName ? [] : ['displayName is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
